var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcImagePicker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.25 68.25H11.7C11.1828 68.25 10.6868 68.0446 10.3211 67.6789C9.95545 67.3132 9.75 66.8172 9.75 66.3V11.7C9.75 11.1828 9.95545 10.6868 10.3211 10.3211C10.6868 9.95545 11.1828 9.75 11.7 9.75H66.3C66.8172 9.75 67.3132 9.95545 67.6789 10.3211C68.0446 10.6868 68.25 11.1828 68.25 11.7V42.25",
    stroke: "#D1D1D1",
    strokeWidth: 3.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 52L32.5 42.25L50.375 50.375",
    stroke: "#D1D1D1",
    strokeWidth: 3.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 32.5C50.2761 32.5 48.6228 31.8152 47.4038 30.5962C46.1848 29.3772 45.5 27.7239 45.5 26C45.5 24.2761 46.1848 22.6228 47.4038 21.4038C48.6228 20.1848 50.2761 19.5 52 19.5C53.7239 19.5 55.3772 20.1848 56.5962 21.4038C57.8152 22.6228 58.5 24.2761 58.5 26C58.5 27.7239 57.8152 29.3772 56.5962 30.5962C55.3772 31.8152 53.7239 32.5 52 32.5V32.5Z",
    stroke: "#D1D1D1",
    strokeWidth: 3.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.75 61.75V71.5M52 61.75H61.75H52ZM71.5 61.75H61.75H71.5ZM61.75 61.75V52V61.75Z",
    stroke: "#D1D1D1",
    strokeWidth: 3.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcImagePicker);
export default __webpack_public_path__ + "static/media/ic_image_picker.3ac7b479757879ffb914101f6033e3c3.svg";
export { ForwardRef as ReactComponent };